export type LoginSearch = {
  token?: string;
  email?: string;
  loggedOut?: boolean;
  origin?: string;
  addAccount?: boolean;
};

/**
 * Validate the `/login` search params.
 *
 * TanStack Router's default `parseSearch` runs every value through `JSON.parse`
 * (`parseSearchWith(JSON.parse)`), so `?addAccount=true` arrives as the boolean
 * `true` and `?loggedOut=1` as the number `1` — not strings. We must accept
 * those parsed forms; a `typeof === 'string'` check drops them, and TanStack
 * then strips the param from the URL entirely (which silently broke the
 * add-account flow). String forms are still accepted for safety.
 *
 * The boolean flags resolve to `undefined` (not `false`) when absent so they
 * aren't serialized back into the URL as `?addAccount=false`.
 */
export function parseLoginSearch(search: Record<string, unknown>): LoginSearch {
  return {
    token: typeof search.token === 'string' ? search.token : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
    loggedOut:
      search.loggedOut === true || search.loggedOut === 'true' || search.loggedOut === '1' || search.loggedOut === 1
        ? true
        : undefined,
    origin: typeof search.origin === 'string' ? search.origin : undefined,
    addAccount: search.addAccount === true || search.addAccount === 'true' ? true : undefined,
  };
}
